import React, { useState, useEffect, Children } from 'react';
import DisclaimerMessage from './DisclaimerMessage';
import { RichText, Text, Image } from '@sitecore-jss/sitecore-jss-react';
import BottomTicker from '../ticker/BottomTicker';
import { withTranslation } from 'react-i18next';

const MobileNavigation = (props) => {
  const {
    navigationResult,
    toolsData,
    quickServiceData,
    headerRightSide,
    topNavigationProps,
    getMenuOpen,
    mainLogo,
    bannerCountdownItem,
  } = props;
  const loginItem = headerRightSide?.children?.find((item) => item.Label.value === 'Login');

  const [searchOpen, setSearchOpen] = useState(false);

  const [disclaimerClosed, setDisclaimerClosed] = useState(false);
  const [disclaimerVisible, setDisclaimerVisible] = useState(true);

  const [menuOpen, setMenuOpen] = useState(false);

  const [activeIndex, setActiveIndex] = useState(null);

  const [toolsVisible, setToolsVisible] = useState(false);
  const [quickServiceVisible, setQuickServiceVisible] = useState(false);

  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  const handleToolsClick = () => {
    setToolsVisible(true);
    setQuickServiceVisible(false);
  };

  const handleQuickServiceClick = () => {
    setQuickServiceVisible(true);
    setToolsVisible(false);
  };

  const handleBackClick = () => {
    setToolsVisible(false);
    setQuickServiceVisible(false);
  };

  useEffect(() => {
    if (menuOpen) {
      setDisclaimerVisible(false);
    } else {
      setDisclaimerVisible(true);
    }
  }, [menuOpen]);

  const handleMenuToggle = () => {
    setMenuOpen((prevState) => !prevState);
    getMenuOpen((prevState) => !prevState);
  };

  const handleCloseClick = () => {
    setDisclaimerClosed(true);
  };

  const handleDisclaimerVisible = (messageSwitch) => {
    messageSwitch ? setDisclaimerVisible(true) : setDisclaimerVisible(false);
  };

  const handleSearchClick = () => {
    setSearchOpen(!searchOpen);
  };

  const handleCollapseClick = (index, e) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const searchData = headerRightSide?.children?.filter((item) => {
    return item.Icon && item.CssClass.value && item.CssClass.value.includes('search_ico');
  });

  const corporatesData = topNavigationProps?.children[1].children?.slice(0, 4).filter((item) => {
    return item.mobileOnly.value !== '1' && item.menuTitle.value === 'Corporates';
  });

  const advirsorsData = topNavigationProps?.children[1].children?.slice(0, 4).filter((item) => {
    return item.mobileOnly.value !== '1' && item.menuTitle.value === 'Advisors';
  });

  const [topNavs, setTopNavs] = useState(0);
  const [topNavsLength, setTopNavsLength] = useState(0);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const innerDiv = document.querySelector('.mobfixed-downloadbtn');
    if (!innerDiv) return;

    if (menuOpen) {
      innerDiv.classList.add('visible-sticky-mob');
    } else {
      innerDiv.classList.remove('visible-sticky-mob');
    }
  }, [menuOpen]);

  useEffect(() => {
    setTopNavs(
      topNavigationProps?.children[1]?.children
        ?.slice(0, -1)
        .filter((item) => item?.mobileOnly?.value !== '1')
    );
    setTopNavsLength(topNavs?.length);
  }, [topNavigationProps]);

  return (
    <div className="mob_nav header_mob_nav hidden-md hidden-lg">
      <DisclaimerMessage
        disclaimerVisible={disclaimerVisible}
        disclaimerClosed={disclaimerClosed}
        handleCloseClick={handleCloseClick}
        handleDisclaimerVisible={handleDisclaimerVisible}
        menuOpen={menuOpen}
      />
      <div className={`mob_meg_menu_wrapper ${menuOpen ? 'disclaimer_close_top' : ''}`}>
        <div className="mob_nav_left">
          <div
            className={`hamburger ${menuOpen ? 'is-active' : ''}`}
            id="hamburger-1"
            onClick={handleMenuToggle}
          >
            <span className="line" />
            <span className="line" />
            <span className="line" />
          </div>
          <a href="/" className="mob_brand_log">
            <Image field={mainLogo?.company_log[0]?.Icon} loading="lazy" />
          </a>
        </div>
        <div className="mob_nav_rightWrap">
          <div className="mob_nav_right">
            {searchData &&
              searchData?.map((item, index) => (
                <div key={index}>
                  <p>{item.Label.value}</p>
                  <img src={item.Icon.src} alt={item.Label.value} loading="lazy" />
                </div>
              ))}
            <a href="tel:18002707000" className="call_ico_mob">
              <img src="https://abconeprod.azureedge.net/dist/ABCD/assets/images/call_dark.svg" loading="lazy" />
            </a>
            {loginItem && (
              <a href={loginItem?.CTA?.url} className="userprof_mob">
                <img src="https://abconeprod.azureedge.net/dist/ABCD/assets/images/user_red.svg" loading="lazy" />
              </a>
            )}
          </div>
        </div>
        <div className={`menu_list_wrapper ${menuOpen ? 'menu_list_wrapper_open' : ''}`}>
          <div className="menu_list_horizontal">
            <ul
              className={`mlh_list ${
                topNavsLength === 3 ? 'mlh_list_three' : topNavsLength === 5 ? 'mlh_list_five' : ''
              } ${toolsVisible || quickServiceVisible ? 'd-none' : ''}`}
              id="nav_pills-tab"
              role="tablist"
            >
              {topNavs &&
                topNavs?.map((navItem, index) => (
                  <li key={index} className="nav-item" role="presentation">
                    {navItem?.menuLink?.url ? (
                      <button className="nav-link">
                        <a className="outlinkanchor" href={navItem?.menuLink?.url}>
                          {navItem?.displayName}
                          <span className="outlinkArroe">
                            <img src="https://abconeprod.azureedge.net/dist/ABCD/assets/images/external-link.svg" loading="lazy" />
                          </span>
                        </a>
                      </button>
                    ) : (
                      <button
                        className={`nav-link ${index === 0 ? 'active' : ''}`}
                        id={`#nav_pills-${navItem?.displayName?.toLowerCase()}-id`}
                        data-bs-toggle="pill"
                        data-bs-target={`#nav_pills-${navItem?.displayName?.toLowerCase()}`}
                        type="button"
                        role="tab"
                        aria-controls={`#nav_pills-${navItem?.displayName?.toLowerCase()}`}
                        aria-selected="true"
                      >
                        {navItem?.displayName}
                      </button>
                    )}
                  </li>
                ))}
            </ul>
            <div
              className={`insurances_back nav_sub_back nav_sub_back_arrow ${
                toolsVisible ? '' : 'd-none'
              }`}
            >
              <a href="javascript:void(0)" onClick={handleBackClick}>
                <span>
                  <img src="https://abconeprod.azureedge.net/dist/ABCD/assets/images/navback-arow.svg" loading="lazy" />
                </span>
                {props?.t('Tools')}
              </a>
            </div>
            <div
              className={`investments_back nav_sub_back nav_sub_back_arrow ${
                quickServiceVisible ? '' : 'd-none'
              }`}
              onClick={handleBackClick}
            >
              <a href="javascript:void(0)">
                <span>
                  <img src="https://abconeprod.azureedge.net/dist/ABCD/assets/images/navback-arow.svg" loading="lazy" />
                </span>
                {props?.t('QuickServices')}
              </a>
            </div>
            <div
              className={`nav-tab-content-wrapper ${
                toolsVisible || quickServiceVisible ? 'd-none' : ''
              }`}
              id="nav_pills-tabContent"
            >
              <div
                className="tab-pane fade show active"
                id="nav_pills-personal"
                role="tabpanel"
                aria-labelledby="nav_pills-personal-tab"
              >
                <div className="accordian_wrapper_mb">
                  <div className="accordion" id="accordionMobNavgsn">
                    {navigationResult?.primary?.map((item, index) => (
                      <div className="accordion-item" key={index}>
                        <div className="accordion-header" id={`headingNav${index + 1}`}>
                          <button
                            className={`accordion-button ${
                              activeIndex === index ? '' : 'collapsed'
                            }`}
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target={`#collapseNav${index + 1}`}
                            aria-expanded={index === 0 ? 'true' : 'false'}
                            aria-controls={`collapseNav${index + 1}`}
                            onClick={() => handleCollapseClick(index)}
                          >
                            <span>
                              <img src={item.menuIcon?.src} alt={`icon-${index}`} loading="lazy" />
                            </span>
                            {item.menuTitle?.value}
                          </button>
                        </div>
                        <div
                          id={`collapseNav${index + 1}`}
                          className="accordion-collapse collapse"
                          aria-labelledby={`headingNav${index + 1}`}
                          data-bs-parent="#accordionMobNavgsn"
                        >
                          <div className="accordion-body">
                            {item?.tabs?.map((subItem, subIndex) => {
                              const hasQuickLinks = subItem?.quickLinksFolder_abfl?.length > 0;
                              return !hasQuickLinks ? (
                                <div className="nav_body_wrapper" key={subIndex}>
                                  <div className="nav_sub_main_tab_wrapper">
                                    <ul className="nav_sub_tab_list_wrapper">
                                      <li className="sub_tab_head">
                                        <a href={subItem?.menuLink?.url}>
                                          {subItem?.menuTitle?.value}
                                          <span className="redi_arrow">
                                            <img
                                              src="https://abconeprod.azureedge.net/dist/ABCD/assets/images/navRedi-arrow.svg"
                                              alt="arrow-icon"
                                              loading="lazy"
                                            />
                                          </span>
                                        </a>
                                      </li>
                                      {subItem?.secondary?.map((subTabItem, subTabIndex) => (
                                        <li className="sub_tab_list" key={subTabIndex}>
                                          <a href={subTabItem?.menuLink?.url}>
                                            {subTabItem?.menuTitle?.value}
                                          </a>
                                        </li>
                                      ))}
                                      {subItem?.menuLink?.url && subItem?.menuLink?.text && (
                                        <li className="sub_tab_list viewall-CTA">
                                          <a href={subItem?.menuLink?.url}>
                                            {subItem?.menuLink?.text}
                                          </a>
                                        </li>
                                      )}

                                      {subItem?.yellowSubTab?.value && (
                                        <RichText field={subItem?.yellowSubTab} editable />
                                      )}
                                      {subItem?.viewAllLink?.url && subItem?.viewAllLink?.text && (
                                        <li className="sub_tab_list viewall-CTA">
                                          <a href={subItem?.viewAllLink?.url}>
                                            {subItem?.viewAllLink?.text}
                                          </a>
                                        </li>
                                      )}
                                    </ul>
                                  </div>
                                </div>
                              ) : (
                                subItem?.quickLinksFolder_abfl?.map((item, subIndex) => (
                                  <div key={subIndex} className="nav_body_wrapper">
                                    <div className="nav_sub_main_tab_wrapper">
                                      <ul className="nav_sub_tab_list_wrapper">
                                        <li className="sub_tab_head">
                                          <a href="javascript:void(0)">
                                            <Text field={item?.heading} editable />
                                            <span className="redi_arrow">
                                              <img
                                                src="https://abconeprod.azureedge.net/dist/ABCD/assets/images/navRedi-arrow.svg"
                                                alt="arrow"
                                              />
                                            </span>
                                          </a>
                                        </li>

                                        {item?.step1[0]?.quickLinks?.map((linkItem, linkIndex) => (
                                          <li className="sub_tab_list" key={linkIndex}>
                                            <a
                                              href={linkItem.link?.url || 'javascript:void(0)'}
                                              target={linkItem.link?.target || '_self'}
                                              className={linkItem.link?.className || ''}
                                            >
                                              {linkItem.label?.value || ''}
                                            </a>
                                          </li>
                                        ))}
                                      </ul>
                                    </div>
                                    {subItem?.relatedReads_abfl?.map((infoItem, infoIndex) => (
                                      <div
                                        className="nav_sub_main_tab_wrapper"
                                        key={`info-${infoIndex}`}
                                      >
                                        <div className="desktop_abfl_nav_info">
                                          <Image field={infoItem.image} editable />
                                          <RichText tag="p" field={infoItem.subHeading} editable />
                                        </div>
                                        <RichText
                                          className="abcl_nav_stats"
                                          field={infoItem.richTextContent}
                                        />
                                      </div>
                                    ))}
                                  </div>
                                ))
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="nav_outlinks_wrpper">
                  <ul>
                    <li>
                      <a href="javascript:;" id="tools_li" onClick={handleToolsClick}>
                        {props?.t('Tools')} <span className="chevron_right_dark col_red" />
                      </a>
                    </li>
                    <li>
                      <a
                        href="javascript:;"
                        id="quickservices_li"
                        onClick={handleQuickServiceClick}
                      >
                        {props?.t('QuickServices')} <span className="chevron_right_dark col_red" />
                      </a>
                    </li>
                    <li>
                      <a href="" data-bs-toggle="modal" data-bs-target="#our_companies_modal">
                        {props?.t('OurCompanies')} <span className="chevron_right_dark col_red" />
                      </a>
                    </li>
                    <li>
                      <a href="/about-us">
                        {props?.t('AboutUs')}{' '}
                        <span className="outlinkArroe">
                          <img src="https://abconeprod.azureedge.net/dist/ABCD/assets/images/external-link.svg" loading="lazy" />
                        </span>
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="mobbtnGroup-mb">
                  <a
                    className="mobbtn-anch getintouch-xm"
                    data-bs-toggle="modal"
                    data-bs-target="#get_in_touch_modal2"
                  >
                    {props?.t('GETINTOUCH')}
                  </a>
                  <a href={loginItem?.CTA?.url} className="mobbtn-anch login-xm">
                    {props?.t('LOGIN')}
                  </a>
                </div>
              </div>
              <div
                className="tab-pane fade"
                id="nav_pills-corporates"
                role="tabpanel"
                aria-labelledby="nav_pills-corporates-tab"
              >
                <div className="accordian_wrapper_mb">
                  <div className="accordion" id="accordionMobNavgsn2">
                    {corporatesData &&
                      corporatesData[0]?.top_nav_tab?.map((item, index) => (
                        <div className="accordion-item" key={index}>
                          <div className="accordion-header" id={`headingNav-corp-${index}`}>
                            <button
                              className="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target={`#navCoraporates${index + 1}`}
                              aria-expanded="false"
                              aria-controls={`navCoraporates${index + 1}`}
                            >
                              <span>
                                <img
                                  src={`/assets/images/nav-ico${index + 1}.svg`}
                                  alt={`Icon ${index + 1}`}
                                  loading="lazy"
                                />
                              </span>
                              {item.Heading.value}
                            </button>
                          </div>
                          <div
                            id={`navCoraporates${index + 1}`}
                            className="accordion-collapse collapse"
                            aria-labelledby={`headingNav-corp-${index}`}
                            data-bs-parent="#accordionMobNavgsnCorporates"
                          >
                            <div className="accordion-body">
                              <div className="nav_body_wrapper">
                                <div className="nav_sub_main_tab_wrapper">
                                  <ul className="nav_sub_tab_list_wrapper">
                                    {item.top_nav_tab_quicklinks.map((link, subIndex) => (
                                      <li className="sub_tab_list" key={subIndex}>
                                        <a href={link.Link.url}>{link.Label.value}</a>
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
                <div className="nav_outlinks_wrpper d-none">
                  <ul>
                    <li>
                      <a href="javascript:;" id="tools_li" onClick={handleToolsClick}>
                        {props?.t('Tools')} <span className="chevron_right_dark col_red" />
                      </a>
                    </li>
                    <li>
                      <a
                        href="javascript:;"
                        id="quickservices_li"
                        onClick={handleQuickServiceClick}
                      >
                        {props?.t('QuickServices')} <span className="chevron_right_dark col_red" />
                      </a>
                    </li>

                    <li>
                      <a href="/about-us">
                        {props?.t('AboutUs')}{' '}
                        <span className="outlinkArroe">
                          <img src="https://abconeprod.azureedge.net/dist/ABCD/assets/images/external-link.svg" loading="lazy" />
                        </span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div
                className="tab-pane fade"
                id="nav_pills-advisors"
                role="tabpanel"
                aria-labelledby="nav_pills-advisors-tab"
              >
                <div className="accordian_wrapper_mb">
                  <div className="accordion" id="accordionMobNavgsn4">
                    {advirsorsData &&
                      advirsorsData[0]?.top_nav_tab?.map((item, index) => (
                        <div className="accordion-item" key={index}>
                          <div className="accordion-header" id={`headingNav-advisor-${index}`}>
                            <button
                              className="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target={`#navAdvisors${index + 1}`}
                              aria-expanded="false"
                              aria-controls={`navAdvisors${index + 1}`}
                            >
                              <span>
                                <img
                                  src={`/assets/images/nav-ico${index + 1}.svg`}
                                  alt={`Icon ${index + 1}`}
                                  loading="lazy"
                                />
                              </span>
                              {item.Heading.value}
                            </button>
                          </div>
                          <div
                            id={`navAdvisors${index + 1}`}
                            className="accordion-collapse collapse"
                            aria-labelledby={`headingNav-advisor-${index}`}
                            data-bs-parent="#accordionMobNavgsnAdvisors"
                          >
                            <div className="accordion-body">
                              <div className="nav_body_wrapper">
                                <div className="nav_sub_main_tab_wrapper">
                                  <ul className="nav_sub_tab_list_wrapper">
                                    {item.top_nav_tab_quicklinks.map((link, subIndex) => (
                                      <li className="sub_tab_list" key={subIndex}>
                                        <a href={link.Link.url}>{link.Label.value}</a>
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
                <div className="nav_outlinks_wrpper">
                  <ul>
                    <li>
                      <a href="javascript:;" id="tools_li" onClick={handleToolsClick}>
                        {props?.t('Tools')} <span className="chevron_right_dark col_red" />
                      </a>
                    </li>
                    <li>
                      <a
                        href="javascript:;"
                        id="quickservices_li"
                        onClick={handleQuickServiceClick}
                      >
                        {props?.t('QuickServices')} <span className="chevron_right_dark col_red" />
                      </a>
                    </li>

                    <li>
                      <a href="/about-us">
                        {props?.t('AboutUs')}{' '}
                        <span className="outlinkArroe">
                          <img src="https://abconeprod.azureedge.net/dist/ABCD/assets/images/external-link.svg" loading="lazy" />
                        </span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div
              className={`nav_sub_tab_wrapper nav_sub_tab_wrapper-mob-new ${
                toolsVisible ? '' : 'd-none'
              }`}
              id="tools_sub_tab"
            >
              <div className="nav_body_wrapper">
                <div className="nav_sub_main_tab_wrapper">
                  {toolsData?.first?.map((tab) => (
                    <ul className="nav_sub_tab_list_wrapper" key={tab?.MenuTitle?.value}>
                      <li className="sub_tab_head">
                        <a href={tab?.MenuLink?.url}>{tab?.MenuTitle?.value}</a>
                      </li>
                      {tab?.second.map((subTab, index) => {
                        return (
                          <React.Fragment key={index}>
                            {subTab?.third?.length > 0 ? (
                              subTab?.third.map((subSubTab) => {
                                return (
                                  <li className="sub_tab_list" key={subSubTab?.MenuTitle?.value}>
                                    <a href={subSubTab?.MenuLink?.url}>
                                      {subSubTab?.MenuTitle?.value}
                                    </a>
                                  </li>
                                );
                              })
                            ) : (
                              <li className="sub_tab_list" key={index}>
                                <a href={subTab?.MenuLink?.url}>{subTab?.MenuTitle?.value}</a>
                              </li>
                            )}
                          </React.Fragment>
                        );
                      })}
                      <li className="sub_tab_list viewall-CTA">
                        <a href={tab?.MenuLink?.url}>{props?.t('ViewAll')}</a>
                      </li>
                    </ul>
                  ))}
                </div>
              </div>
            </div>
            <div
              className={`nav_sub_tab_wrapper nav_sub_tab_wrapper-mob-new ${
                quickServiceVisible ? '' : 'd-none'
              }`}
              id="quickservices_sub_tab"
            >
              <div className="nav_body_wrapper">
                <div className="nav_sub_main_tab_wrapper">
                  {quickServiceData?.map((tab) => (
                    <ul className="nav_sub_tab_list_wrapper" key={tab?.menuTitle?.value}>
                      <li className="sub_tab_head">
                        <a href={tab?.menuLink?.url}>{tab?.menuTitle?.value}</a>
                      </li>
                      {tab?.nav_links?.map((subTab) => (
                        <li className="sub_tab_list" key={subTab?.label?.value}>
                          <a href={subTab?.link?.url}>{subTab?.label?.value}</a>
                        </li>
                      ))}
                      <li className="sub_tab_list viewall-CTA">
                        <a href={tab?.menuLink?.url}>{props?.t('ViewAll')}</a>
                      </li>
                    </ul>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {bannerCountdownItem && <BottomTicker bannerCountdownItem={bannerCountdownItem} />}
    </div>
  );
};

export default withTranslation()(MobileNavigation);
